import { render, staticRenderFns } from "./CosmoTour.vue?vue&type=template&id=6af790e4&lang=pug&"
import script from "./CosmoTour.vue?vue&type=script&lang=js&"
export * from "./CosmoTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports